<template>
  <div :class="[$style.wrapper, closed && $style.closed]" :style="{ width: width ? width : null }">
    <div :class="$style.top" v-if="title">
      <span>K</span>{{title}}
    </div>
    <div :class="$style.body" :style="{padding: padding}">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'window',
  props: {
    title: String,
    width: String,
    defaultClosed: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: '1.5rem',
    },
  },
  data() {
    return {
      closed: this.defaultClosed,
    }
  },
  methods: {
    close() {
      this.closed = true
    },
    open() {
      this.closed = false
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  box-shadow: 0.7rem 0.7rem 4rem rgba(0, 0, 0, 0.25);
  background: #fff;
  border-radius: 0.5rem;
  position: absolute;
  z-index: 9;
  transform: translateZ(0);
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.closed {
  transform: scale(0.6);
  opacity: 0;
  pointer-events: none;
}

.top {
  padding: 0.5rem 0;
  @include vtFont;
  font-size: 2.1rem;
  border-bottom: 0.3rem solid #F0F0F5;
  text-align: center;

  span {
    color: #23D1AE;
  }
}

.body {
  padding: 1.5rem;
}
</style>
